<div class="page-widget-x-path-container">
    <button class="btn btn-transparent" (click)="moveLeft()" *ngIf="!hideLeftBtn"><i class="app-icon wi wi-arrow-left"></i></button>
    <div class="page-widget-x-path">
        <ol class="breadcrumb">
            <li *ngFor="let parent of parents" [ngClass]="{active: parent.name === selectedWidgetName}" (click)="selectWidget(parent)">
                <a>{{parent.name}}</a>
            </li>
        </ol>
    </div>
    <button class="btn btn-transparent pull-right" (click)="moveRight()" *ngIf="!hideRightBtn"><i class="app-icon wi wi-arrow-right"></i></button>
  <div class="zoom-content">
  <ul   >
  <li class="wm-design-more-actions wm-workspace-action zoombutton" container="body"
      [ngClass]="{'prefab-project': projectService.isPrefabType()}"  title="{{locale.PAGE_ADJUSTMENTS}}">
    <button [disabled]="zoomService.zoomPercentage$.getValue() === 50" name="wm-zoominout-design-workspace" (click)= zoomService.decreaseZoom() class="wm-workspace-action wm-icon24 wms wms-remove"></button>
    <span class="zoomvalue">{{ (zoomService.zoomPercentage$ | async) | number:'1.0-0' }}%</span>
    <button [disabled]="zoomService.zoomPercentage$.getValue() === 150" name="wm-zoominout-design-workspace" (click)= zoomService.increaseZoom() class="wm-workspace-action wm-icon24 wms wms-plus"></button>
  </li>

  </ul>
  </div>
</div>
